import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import { setDealCancelled } from 'cache/deal-status'
import { setShouldDisableActionBtns } from 'cache/form-valid'
import { DEAL_STATUS, setDealInfo } from 'cache/latest-deal-info'
import { userProfileVar } from 'cache/user-profile'
import errorMessages from 'constants/errorMessages'
import GET_DEAL_INFO_QUERY from 'queries/deal-info'
import { MessageType } from 'ts/enums/messageType.enums'
import { IDealInfoAPIResponse } from 'ts/interfaces/deal/deal.interfaces'
import { useDealPendingActions } from './use-deal-pending-actions'

export const useLoadDealInfo = () => {
  const { dealNumber } = useParams<{ dealNumber: string }>()
  const parsedDealNumber = Number(dealNumber)
  const { fetchPendingActions } = useDealPendingActions()
  const [loadDealQuery, { data, loading, error }] = useLazyQuery<IDealInfoAPIResponse, any>(
    GET_DEAL_INFO_QUERY,
    { fetchPolicy: 'no-cache' }
  )

  const handleGetDealInfo = async (dealId: any) => {
    try {
      await loadDealQuery({
        variables: {
          dealId,
          dealNumber: parsedDealNumber,
        },
      }).then((res) => {
        res.data && setDealInfo(res?.data)
        const isDealCancelled =
          res?.data?.dealStatus?.lastStatus?.toLowerCase() === DEAL_STATUS.CANCELLED.toLowerCase()

        if (isDealCancelled) {
          setDealCancelled(true)
          setShouldDisableActionBtns(true)
          setAlertQueue({ type: MessageType.WARNING, message: errorMessages.DEAL_CANCELLED })
        }
        res.data?.regionalSettings.regionCode &&
          fetchPendingActions(
            dealId,
            res.data?.regionalSettings.regionCode ?? '',
            res.data?.dealSummary.busGroupCode ?? '',
            userProfileVar()?.emailAddress ?? ''
          )
      })
    } catch (error) {
      return { error }
    }
  }

  return {
    getDealInfo: handleGetDealInfo,
    data,
    loading,
    error,
  }
}
